import React, { Component } from 'react';
import styled from '@emotion/styled';
import dimensions from "styles/dimensions";
import { Inner } from 'styles/structure';
import Content from 'components/_ui/Content';

const PositionsContainer = styled.div`  
  & + * {
    margin-top: 8rem;
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    iframe {
      // the apparent width of the standard container inside the iframe
      min-width: 75rem !important;
    }
    
    & + * {
      margin-top: 10.4rem;
    }
  }
`;

const PositionsHeader = styled.header`
  & + * {
    margin-top: 3.2rem;
  }
  
  h3 {
    & + * {
      margin-top: 1.6rem;
    }
  }
  
  p {
    max-width: 74.8rem;
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    & + * {
      margin-top: 4rem;
    }
  }
`;

const PositionsContent = styled.div``;

class Positions extends Component {
  render() {
    const self = this;

    return (
      <PositionsContainer>
        <Inner>
          <PositionsHeader>
            {self.props.heading && <h3>{self.props.heading}</h3>}
            {self.props.content && <Content content={self.props.content}/>}
          </PositionsHeader>

          <PositionsContent>
            <script type="comeet-careers"/>
          </PositionsContent>
        </Inner>
      </PositionsContainer>
    );
  }
}

export default Positions;
